<template>
	<!-- ViewClassroomCurriculum.vue:
		강의실 > 커리큘럼 화면 (online-class.html, online-class1.html) -->

	<fragment>
		<class-header
			:subname="lecture.category"
			:name="lecture.lecName"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:sysmenuActive="false"
			:icon="lecture.lecIcon?lecture.lecIcon.atchFileId:''"
		></class-header>

		<section ref="container" class="container">
			<!-- side menus -->
			<nav class="side-nav">
				<a @click="$router.push('/classroom/'+$route.params.lecId+'/exam')" class="btn full-width round m-b-10">돌아가기</a>
			</nav>
			<!-- //end .side-nav -->
			<div class="container-fiuld clearfix">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">시험 관리</div>
					<div class="pull-right p-10">
						<button class="btn-sm bg-deepblue text-white round" @click="modals.ModalExamAppend.show=true">문항추가</button>
					</div>
				</div>
				<div class="white-box m-t-10 clearfix">
					<div class="input-group full-width">
						<span class="input-group-addon text-left">
							<p class="f-18 m-b-0 text-bold text-blue">
								시험명 <input class="form-control round f-18 text-blue text-left m-b-0 w400" type="text" style="float: none;" v-model="data.examName" autocomplete="off">
								<span class="f-12 text-nomal text-lightgray">{{data.examName.length}} / 30</span>
							</p>
							<p class="f-18 m-t-10 m-b-0 text-bold text-blue">
								시험시간 <input class="form-control round f-18 text-blue text-left m-b-0 w100" type="number" style="float: none;" v-model="data.examTime" autocomplete="off">
								<span class="f-12 text-nomal text-lightgray">분</span>
							</p>
							<p class="f-18 m-t-10 m-b-0 text-bold text-blue">
								응시기간 :
								<VueCtkDateTimePicker v-model="data.examStart" :no-value-to-custom-elem="true" :no-label="true" format="YYYY-MM-DD" :no-button-now="true" :no-header="true" :only-date="true" class="_date-time-picker" style="float:none;">
									<input type="text" class="form-control round text-left m-b-0 w200" style="float:none;" :value="data.examStart" autcomplete="off">
								</VueCtkDateTimePicker>
								<VueCtkDateTimePicker v-model="data.examEnd" :no-value-to-custom-elem="true" :no-label="true" format="YYYY-MM-DD" :no-button-now="true" :no-header="true" :only-date="true" class="_date-time-picker" style="float:none;">
									<input type="text" class="form-control round text-left m-b-0 w200" style="float:none;" :value="data.examEnd" autcomplete="off">
								</VueCtkDateTimePicker>
							</p>
						</span>
					</div>
					<textarea class="full-width m-t-15 v-mid" cols="30" rows="10" placeholder="시험 설명" v-model="data.info"></textarea>
					<span class="f-12 text-nomal pull-right text-lightgray">{{data.info.length}} / 500</span>
				</div>


				<div class="white-box clearfix" v-for="(item, examItemIdx) in data.examItemList" :item="item" :index="examItemIdx" :key="'classroom-exam-'+examItemIdx+hash(item)">
					<div class="input-group full-width m-b-30 p-b-10 b-b">
						<span class="input-group-addon w20 v-mid f-16 text-left">{{examItemIdx+1}}.</span>
						<span class="input-group-addon w100 v-mid p-r-5">
							<select class="form-control-sm full-width round m-b-0" v-model="item.type" readonly>
								<option>객관식</option>
								<option>주관식</option>
							</select>
						</span>
						<span class="input-group-addon p-r-5">
							<input class="form-control-sm full-width text-left round m-b-0" type="text" v-model="item.itemName" readonly>
						</span>
						<span class="input-group-addon w120 v-mid">
							<button class="btn-sm btn-red round" @click="data.examItemList.splice(examItemIdx,1)">문항제거</button>
						</span>
					</div>
					<!--
					<div class="input-group full-width m-b-10">
						<span class="input-group-addon w60 v-mid p-r-5">
							<input id="table-check3" class="checkbox4" type="radio" name="dd">
							<label for="table-check3">체크버튼</label>
						</span>
						<span class="input-group-addon v-mid p-r-5">
							<input class="form-control-sm full-width text-left round m-b-0" type="text" value="강의 수강생" >
						</span>
						<span class="input-group-addon text-blue w40 v-mid p-r-5">
						</span>
						<span class="input-group-addon w80 v-mid">
							<a class="move" href="#none">이동</a>
							<a class="del" href="#none">삭제</a>
						</span>
					</div>
					<div class="input-group full-width m-b-5">
						<span class="input-group-addon w60 v-mid p-r-5">
							<input id="table-check3" class="checkbox4" type="radio" name="dd">
							<label for="table-check3">체크버튼</label>
						</span>
						<span class="input-group-addon v-mid p-r-5">
							<input class="form-control-sm full-width text-left round m-b-0" type="text" value="강의 수강생">
						</span>
						<span class="input-group-addon w40 v-mid p-r-5">
							<input id="file" type="file" style="display: none;">
							<label for="file" class="btn-sm btn-darkgray plus round f-12" type="button">
								<img class="v-mid" src="images/plus.png" width="15" alt="">
							</label>
						</span>
						<span class="input-group-addon text-blue w40 v-mid p-r-5">
							정답!
						</span>
						<span class="input-group-addon w80 v-mid">
							<a class="move" href="#none">이동</a>
							<a class="del" href="#none">삭제</a>
						</span>
					</div>
					<div class="input-group full-width m-b-10">
						<span class="input-group-addon w60 v-mid p-r-5">
						</span>
						<span class="input-group-addon v-mid p-r-5">
							<div class="examImg text-center m-b-15">
								<img src="http://placehold.it/200x100" alt="">
							</div>
						</span>
						<span class="input-group-addon w60 v-mid p-r-5">
						</span>
						<span class="input-group-addon w80 v-mid">
						</span>
					</div>
					-->
				</div>
				<div class="b-t p-15 p-l-0 m-t-30 m-b-30 clearfix">
					<button class="btn pull-right round w160" @click="modals.ModalExamAppend.show=true">문항추가</button>
				</div>
			</div>
		</section>

		<modal-exam-append :config="modals.ModalExamAppend" @close="modals.ModalExamAppend.show=false;" :key="hash(modals.ModalExamAppend)" @append="append" @alert="alert"></modal-exam-append>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>

		<common-footer></common-footer>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import fnGetLec from '../mixins/fnGetLec.js'
import ClassHeader from '../components/ClassHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import ModalExamAppend from '../modals/ModalExamAppend.vue'
import ModalAlert from '../modals/ModalAlert.vue'

import axios from 'axios'
import server from '../statics/server.js'

export default {
	// 컴포넌트 명
	name: 'ViewClassroomExamRegister',
	mixins: [fnAdjustHeight,fnGetLec],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ClassHeader,
		CommonFooter,
		VueCtkDateTimePicker,
		ModalExamAppend,
		ModalAlert
	},

	mounted: async function() {
		const { lecId, curriculumId } = this.$route.params;
		this.lecture = await this.getLecInfo(lecId);
		if(this.lecture.classroomOpt.indexOf("출결")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='출결')), 1 );
		if(this.lecture.classroomOpt.indexOf("과제")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=="과제")), 1 );
		if(this.lecture.classroomOpt.indexOf("설문")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='설문')), 1 );
		if(this.lecture.classroomOpt.indexOf("시험")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='시험')), 1 );
		//if(this.lecture.classroomOpt.indexOf("동영상 등록")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='강의 목차')), 1 );
		this.curriculum = await this.getCurriculumInfo(curriculumId);
	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			menus : [
				{name:'강의 목차',link:"/classroom/"+this.$route.params.lecId+"/curriculum",selected:false},
				{name:'수강관리',link:"/classroom/"+this.$route.params.lecId+"/apply",selected:false},
				{name:'출결',link:"/classroom/"+this.$route.params.lecId+"/attendance",selected:false},
				{name:'시험',link:"/classroom/"+this.$route.params.lecId+"/exam",selected:true},
				{name:'과제',link:"/classroom/"+this.$route.params.lecId+"/assignment",selected:false},
				{name:'설문',link:"/classroom/"+this.$route.params.lecId+"/survey",selected:false},
				{name:'게시판',link:"/classroom/"+this.$route.params.lecId+"/board",selected:false},
			],
			buttons : [
				{name:'저장하기', fn:this.register}
			],
			modals: {
				ModalExamAppend: ModalExamAppend.default(),
				ModalAlert: ModalAlert.default(),
			},
			lecture: {},
			curriculum: {},
			data: {
				examName: "",
				examStart: "",
				examEnd: "",
				examTime: 60,
				info: "",
				questCount: 0,
				examItemList: [],
				examItemMappingList: []
			}
		}
	},



	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		append: function(items) {
			this.data.examItemList = [...this.data.examItemList, ...items];
			this.data.examItemMappingList = [...this.data.examItemMappingList, ...items.map(i=>{return {examItemId:i.examItemId}})];
			this.data.questCount = this.data.examItemList.length;
		},
		alert: function(msg) {
			this.modals.ModalAlert.msg = msg;
			this.modals.ModalAlert.show = true;
		},
		register: function() {
			axios.put(server.addr()+"/exam", [this.data]).then( (response) => {
				axios.patch(server.addr()+"/curriculumExamMapping", {
					examId: response.data.list[0].examId,
					curriculumId: this.$route.params.curriculumId
				}).then( () => {
					this.$router.push('/classroom/'+this.$route.params.lecId+"/exam");
				})
			})
		}
	}
}
</script>
